import { render } from "./MyNavbar.vue?vue&type=template&id=8f4c7328&scoped=true"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"

import "./MyNavbar.vue?vue&type=style&index=0&id=8f4c7328&scoped=true&lang=css"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4c7328"]])

export default __exports__